(function(){

    var g_feedbackForm;

    addBeforeRelated();
    bindEvents();

    function addBeforeRelated(){
        var related = document.getElementById('related-articles');
        var feedBick = document.getElementById('feedbick');
        if(related && feedBick){
            related.parentNode.insertBefore(feedBick, related);
        }
    }

    function bindEvents(){
        g_feedbackForm = document.getElementById("feedbick");
        if(g_feedbackForm){
            g_feedbackForm.addEventListener("submit", onSubmitFeedback);
        }
    }

    function onSubmitFeedback(e){
        // Prevent the default form submission
        e.preventDefault(); 

        var formData = new FormData(g_feedbackForm);
        formData.append("liked", e.target.submited === '1');
        formData.append("disliked", e.target.submited === '0');

        var xhr = new XMLHttpRequest();
        xhr.open("POST", g_feedbackForm.getAttribute('action'), true);

        xhr.onreadystatechange = function() {

            g_feedbackForm.innerHTML = '<b>🙏 Thanks for letting us know!</b>'

            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    console.log(xhr.responseText);
                    // Handle a successful response from the server here
                    console.log("AJAX POST successful:", xhr.responseText);
                } else {
                    // Handle errors here
                    console.error("AJAX POST error:", xhr.status, xhr.statusText);
                }
            }
        };

        xhr.send(formData);


        return false;
    }

})();